<template>
    <section id="footer" class="bg-primary">

        <b-container class="wrap">
            <b-row>
                <b-col lg="3" md="6" class="mb-4 mb-lg-0 text-center text-md-left">
                    <img class="logo" src="@/assets/img/logo-pedade-rodape.svg" :alt="$appName"/>
                    <ul>
                       <li><router-link to="/sobre">Sobre a Pedale</router-link></li>
                        <li><router-link to="/como-funciona-a-pedale">Como Funciona</router-link></li>

                        <li><router-link to="/ajuda">Perguntas Frequentes</router-link></li>
                        <li><router-link to="/cartilha-anunciante">Cartilha para o Anfitrião</router-link></li>
                       <li><router-link to="/cartilha-ciclista">Cartilha para o Ciclista</router-link></li>
                    </ul>
                </b-col>
                <b-col lg="3" md="6" class="mb-4 mb-lg-0 text-center text-md-left">
                    <h6>Fale com a gente</h6>
                    <ul>
                        <li><router-link to="/contato">Contatos</router-link></li>
                        <li><router-link to="/politicas-pedale/termos-de-uso">Termos de Uso</router-link></li>
                        <li><router-link to="/politicas-pedale/politica-de-privacidade">Política de Privacidade</router-link></li>
                        <li><router-link to="/politicas-pedale/acordo-de-locacao">Acordo de Locação</router-link></li>
                    </ul>
                </b-col>
                <b-col lg="3" md="6" class="mb-4 mb-lg-0 text-center text-md-left">
                    <h6>Acesso</h6>
                    <ul>

                       <li v-if="currentUser"><router-link to="/painel/anunciante/minhas-bicicletas">Painel do Anfitrião</router-link></li>
                       <li v-if="currentUser"><router-link to="/painel/ciclista/minhas-reservas">Painel do Ciclista</router-link></li>
                       <li v-if="currentUser"><router-link to="/painel/minha-conta/perfil">Minha Conta</router-link></li>


                        <li  v-if="!currentUser"><router-link to="/login">Login</router-link></li>
                       <li  v-if="!currentUser"><router-link to="/registrar">Registrar</router-link></li>
                    </ul>
                </b-col>
                <b-col lg="3" md="6" class="mb-4 mb-lg-0 text-center text-md-left">
                    <h6>Redes Sociais</h6>
                    <ul class="social-icons">
                        <li><a href="https://www.facebook.com/vaidepedale" target="_blank"><v-icon name="brands/facebook-square" scale="3"></v-icon></a></li>
                        <li><a href="https://instagram.com/vaidepedale" target="_blank"><v-icon name="brands/instagram" scale="3"></v-icon></a></li>
                    </ul>
                </b-col>
            </b-row>
        </b-container>
        <div class="copyright">
            <b-container>
                <b-row>
                    <b-col md="6" class="text-center text-md-left">
                        Copyright ©  {{this.year}} Pedale. Todos os direitos reservados.
                    </b-col>
                    <b-col md="6" class="text-center text-md-right">
                        <a href="#" id="back_top" title="Voltar ao Topo" class="anchor-animated"><i class="el-icon-arrow-up" aria-hidden="true"></i> TOPO</a>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </section>
</template>

<script>

 export default {
     name: 'Footer',
     props: {},

     data() {
         return {
            year: new Date().getFullYear(),
         }
     },
     methods: {},
     computed: {
         currentUser() {
             return this.$store.state.auth.user;
         }
     },
     mounted() {

     },
 };
</script>
